module.exports = __webpack_public_path__ + "static/image/font/pc/baemin-geullim-4.ver2_0_2.jpg?e27217da";